import createDynamicApi from '../utils/generateApiSlice.js';
import { BASEURL, CUSTOMERS } from '../api/endpoints.js';

export const customersApi = createDynamicApi({
    reducerPath: 'customersApi',
    baseEndpoint: BASEURL + CUSTOMERS
});

export const customersCustomApi = customersApi.injectEndpoints({
    endpoints: (builder) => ({
        getCurrentCustomerKey: builder.query({
            query: (warehouse) => ({
                url: `/GetCurrentKey?Warehouse=${warehouse}`,
                method: 'GET',
            }),
            transformResponse: (response) => response.Response,
        }),
    }),
});

export const {
    useGetCurrentCustomerKeyQuery,
    useGetAllQuery: useGetCustomersQuery,
    useAddMutation: useAddCustomerMutation,
    useUpdateMutation: useUpdateCustomerMutation,
    useDeleteMutation: useDeleteCustomerMutation,
} = customersApi;